export const IconCalendar = (props) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_3598_1119)">
        <path
          d="M12.375 7.3125C12.375 7.16332 12.4343 7.02024 12.5398 6.91475C12.6452 6.80926 12.7883 6.75 12.9375 6.75H14.0625C14.2117 6.75 14.3548 6.80926 14.4602 6.91475C14.5657 7.02024 14.625 7.16332 14.625 7.3125V8.4375C14.625 8.58668 14.5657 8.72976 14.4602 8.83525C14.3548 8.94074 14.2117 9 14.0625 9H12.9375C12.7883 9 12.6452 8.94074 12.5398 8.83525C12.4343 8.72976 12.375 8.58668 12.375 8.4375V7.3125Z"
          fill="currentColor"
        />
        <path
          d="M3.9375 0C4.08668 0 4.22976 0.0592632 4.33525 0.164752C4.44074 0.270242 4.5 0.413316 4.5 0.5625V1.125H13.5V0.5625C13.5 0.413316 13.5593 0.270242 13.6648 0.164752C13.7702 0.0592632 13.9133 0 14.0625 0C14.2117 0 14.3548 0.0592632 14.4602 0.164752C14.5657 0.270242 14.625 0.413316 14.625 0.5625V1.125H15.75C16.3467 1.125 16.919 1.36205 17.341 1.78401C17.7629 2.20597 18 2.77826 18 3.375V15.75C18 16.3467 17.7629 16.919 17.341 17.341C16.919 17.7629 16.3467 18 15.75 18H2.25C1.65326 18 1.08097 17.7629 0.65901 17.341C0.237053 16.919 0 16.3467 0 15.75V3.375C0 2.77826 0.237053 2.20597 0.65901 1.78401C1.08097 1.36205 1.65326 1.125 2.25 1.125H3.375V0.5625C3.375 0.413316 3.43426 0.270242 3.53975 0.164752C3.64524 0.0592632 3.78832 0 3.9375 0V0ZM1.125 4.5V15.75C1.125 16.0484 1.24353 16.3345 1.4545 16.5455C1.66548 16.7565 1.95163 16.875 2.25 16.875H15.75C16.0484 16.875 16.3345 16.7565 16.5455 16.5455C16.7565 16.3345 16.875 16.0484 16.875 15.75V4.5H1.125Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3598_1119">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
